"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REFRESH_URL = exports.AUTH_ERROR_DESCRIPTIONS = exports.AUTH_PAUSE_SIGN_IN = exports.AUTH_INVALID_TOKEN = exports.AUTH_TEMPORARILY_UNAVAILABLE = exports.AUTH_SERVER_ERROR = exports.AUTH_INVALID_SCOPE = exports.AUTH_UNSUPPORTED_RESPONSE_TYPE = exports.AUTH_ACCESS_DENIED = exports.AUTH_UNAUTHORIZED_CLIENT = exports.AUTH_INVALID_REQUEST = exports.TOKEN_CHECKING_INTERVAL = exports.ACCESS_TOKEN_MIN_UPDATE_DIFF = exports.ALYCE_REFRESH_COOKIE = exports.ALYCE_TOKEN_COOKIE = void 0;
var ALYCE_TOKEN_COOKIE = 'alyce_access_token';
exports.ALYCE_TOKEN_COOKIE = ALYCE_TOKEN_COOKIE;
var ALYCE_REFRESH_COOKIE = 'alyce_refresh_token';
exports.ALYCE_REFRESH_COOKIE = ALYCE_REFRESH_COOKIE;
var ACCESS_TOKEN_MIN_UPDATE_DIFF = 300; // 300 seconds

exports.ACCESS_TOKEN_MIN_UPDATE_DIFF = ACCESS_TOKEN_MIN_UPDATE_DIFF;
var TOKEN_CHECKING_INTERVAL = 3600 * 1000; // 1 hour

exports.TOKEN_CHECKING_INTERVAL = TOKEN_CHECKING_INTERVAL;
var AUTH_INVALID_REQUEST = 'invalid_request';
exports.AUTH_INVALID_REQUEST = AUTH_INVALID_REQUEST;
var AUTH_UNAUTHORIZED_CLIENT = 'unauthorized_client';
exports.AUTH_UNAUTHORIZED_CLIENT = AUTH_UNAUTHORIZED_CLIENT;
var AUTH_ACCESS_DENIED = 'access_denied';
exports.AUTH_ACCESS_DENIED = AUTH_ACCESS_DENIED;
var AUTH_UNSUPPORTED_RESPONSE_TYPE = 'unsupported_response_type';
exports.AUTH_UNSUPPORTED_RESPONSE_TYPE = AUTH_UNSUPPORTED_RESPONSE_TYPE;
var AUTH_INVALID_SCOPE = 'invalid_scope';
exports.AUTH_INVALID_SCOPE = AUTH_INVALID_SCOPE;
var AUTH_SERVER_ERROR = 'server_error';
exports.AUTH_SERVER_ERROR = AUTH_SERVER_ERROR;
var AUTH_TEMPORARILY_UNAVAILABLE = 'temporarily_unavailable';
exports.AUTH_TEMPORARILY_UNAVAILABLE = AUTH_TEMPORARILY_UNAVAILABLE;
var AUTH_INVALID_TOKEN = 'invalid_token';
exports.AUTH_INVALID_TOKEN = AUTH_INVALID_TOKEN;
var AUTH_PAUSE_SIGN_IN = 'pause_sign_in';
exports.AUTH_PAUSE_SIGN_IN = AUTH_PAUSE_SIGN_IN;
var AUTH_ERROR_DESCRIPTIONS = {
  [AUTH_INVALID_REQUEST]: 'User not found',
  [AUTH_UNAUTHORIZED_CLIENT]: 'Wrong email or password',
  [AUTH_ACCESS_DENIED]: 'Access denied',
  [AUTH_UNSUPPORTED_RESPONSE_TYPE]: 'Access denied',
  [AUTH_INVALID_SCOPE]: 'Access denied',
  [AUTH_SERVER_ERROR]: 'Internal server error',
  [AUTH_TEMPORARILY_UNAVAILABLE]: 'Service temporarily unavailable',
  [AUTH_INVALID_TOKEN]: 'Token validation error',
  [AUTH_PAUSE_SIGN_IN]: 'Access denied'
};
exports.AUTH_ERROR_DESCRIPTIONS = AUTH_ERROR_DESCRIPTIONS;
var REFRESH_URL = "/auth/refresh";
exports.REFRESH_URL = REFRESH_URL;